import React, { useState } from "react";
import ManualesCard from "../../components/atoms/ManualesCard/ManualesCard";
import ManualesCardAgregar from "../../components/atoms/ManualesCardAgregar/ManualesCardAgregar";
import AnimatedCard from "../../components/molecules/AnimatedCard/AnimatedCard";
import ValidationMessage from "../../components/atoms/ValidationMessage/ValidationMessage";
import Input from "../../components/atoms/Input/Input";
import TextArea from "../../components/atoms/TextArea/TextArea";
import Button from "../../components/atoms/Button/Button";
import { validateData } from "../../utiles/ValidateEntries";
// import { Dialog } from 'primereact/dialog';
const SeccionManuales = () => {
    const data = [
        {
            titulo: "Crea tu cuenta en APP Restaurant",
            texto: "Registra tu cuenta para poder usar el app de Restaurant.",
            manual: "pdf",
        },
        {
            titulo: "Agrega un negocio",
            texto: "Agrega un nuevo negocio a tu cuenta",
            manual: "pdf",
        },
        {
            titulo: "Crea tu menú / catalogo ",
            texto: "Crea la lista de artículos organizados por grupos",
            manual: "pdf",
        },
        {
            titulo: "Agregar una sucursal y mostradores",
            texto: "Agregar una nueva sucursal a un negocio y crea mostradores",
            manual: "pdf",
        },
        {
            titulo: "Asociar una terminal a la sucursal",
            texto: "Obtener el código de la sucursal para asociar una terminal a la sucursal.",
            manual: "pdf",
        },
        {
            titulo: "Liga un Menu / Catalogo a tu sucursal",
            texto: "Liga la lista de articulos que se venderan en una sucursal.",
            manual: "pdf",
        },
        {
            titulo: "Registrar Tarjeta de Debito o credito",
            texto: "Registrar la tarjeta de credito donde se cobrara la mens.",
            manual: "pdf",
        },
    ];
    const [visible, setVisible] = useState(false);

    const [manuals, setManuals] = useState({
        title: "",
        description: "",
        file: "",
    });

    const [emptyField, setEmptyField] = useState({});

    const handleChangeDatas = (e) => {
        const { name, value } = e.currentTarget;
        setManuals((prevent) => ({
            ...prevent,
            [name]: value,
        }));

        setEmptyField((prev) => ({
            ...prev,
            [name]: false,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        try {
            const { status, emptyFields } = validateData(manuals);

            // Guardar los campos vacíos en el estado
            setEmptyField(emptyFields);

            if (!status) {
                console.error(
                    "Por favor, completa todos los campos requeridos."
                );
                return;
            }
        } catch (error) {
            console.error("Ocurrio un error", error);
        }
    };

    return (
        <div className="SeccionManuales">
            <ManualesCardAgregar
                onClick={() => {
                    setVisible(true);
                }}
            ></ManualesCardAgregar>
            {data.map((item, key) => {
                return (
                    <>
                        <ManualesCard
                            titulo={item.titulo}
                            text={item.texto}
                        ></ManualesCard>
                    </>
                );
            })}

            {visible && (
                <AnimatedCard
                    setClose={setVisible}
                    title="Nuevo Manual"
                    size="md"
                    variant="elegant"
                    coloredHeader={true}
                >
                    <form
                        onSubmit={handleSubmit}
                        className="customModalMan__form"
                    >
                        <ValidationMessage show={emptyField.title}>
                            <Input
                                type="text"
                                name={"title"}
                                placeholder={"Title"}
                                id={"title"}
                                onChange={handleChangeDatas}
                                show={emptyField.title}
                            />
                        </ValidationMessage>
                        <ValidationMessage show={emptyField.description}>
                            <TextArea
                                name={"description"}
                                placeholder={"description"}
                                id={"description"}
                                onChange={handleChangeDatas}
                                show={emptyField.description}
                            />
                        </ValidationMessage>
                        <Button
                            text={"Guardar"}
                            className="degrad customModalMan__form__btn"
                        />
                    </form>
                </AnimatedCard>
            )}
        </div>
    );
};
export default SeccionManuales;
